module.exports = __webpack_public_path__ + "static/media/MCSE_SharePoint_Blk.d2dfc4df.png";


//////////////////
// WEBPACK FOOTER
// ./src/photos/MCSE_SharePoint_Blk.png
// module id = 368
// module chunks = 0